import { createContext } from 'react'
import type { AgentsContextType } from '../../types/agents'

const AgentsContext = createContext<AgentsContextType | undefined>(undefined)

export default AgentsContext
